import React from 'react';
import { Trans, useTranslator } from 'tradera/lang/translate';
import qs from 'qs';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export const FormFooter = ({ registerLink, isCompanyLink, logoOnly }) => {
    const { t } = useTranslator();
    const countryCodeFromQs = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
    }).countryCode;
    const countryCodeUrlSuffix = countryCodeFromQs
        ? `?countryCode=${countryCodeFromQs}`
        : '';

    return (
        <div className={'text-center mb-4'}>
            {!logoOnly && (
                <>
                    <div className={'mb-2'}>
                        <a
                            className="link"
                            href={`${registerLink}${countryCodeUrlSuffix}`}>
                            {isCompanyLink
                                ? t('registration_company_link')
                                : t('registration_private_link')}
                        </a>
                    </div>
                    <div className={'mb-4'}>
                        <Trans
                            i18nKey="registration_already_member_Trans"
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                            components={{ a: <a className="link" /> }}
                        />
                    </div>
                </>
            )}
            <FormFooterLogo />
        </div>
    );
};
